import { useEffect, useState } from "react"

export interface UserLocation {
    lat: number
    lon: number
}

export const useUserLocation = () => {
    const [userLoc, setUserLoc] = useState<UserLocation | null>(null)

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (pos) =>
                    setUserLoc({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
                // eslint-disable-next-line no-console
                (err) => console.log("Error fetching location:", err),
            )
        } else {
            // eslint-disable-next-line no-console
            console.log("Geolocation not supported")
        }
    }, [])

    return userLoc
}
